import { RadioStyleConfig } from '../types';

export const styleConfig: RadioStyleConfig = {
  baseStyle: {
    control: {
      w: '5',
      h: '5',
      border: '0.1',
      _checked: {
        _focusVisible: {
          bg: 'blue.500',
          borderColor: 'blue.500',
        },
        _hover: {
          bg: 'blue.200',
          borderColor: 'blue.200',
        },
      },
      _disabled: {
        borderColor: 'grey.300',
        _checked: {
          bg: 'blue.200',
          color: 'blue.50',
        },
        _hover: {
          borderColor: 'grey.300',
        },
        _focusVisible: {
          borderColor: 'grey.300',
        },
      },
      _invalid: {
        borderColor: 'red.500',
      },
    },
  },
  variants: {
    default: {
      control: {
        borderColor: 'grey.300',
        _hover: {
          borderColor: 'blue.200',
        },
        _focusVisible: {
          borderColor: 'blue.800',
        },
      },
    },
    success: {
      control: {
        borderColor: 'green.500',
        _hover: {
          borderColor: 'green.500',
        },
        _focusVisible: {
          borderColor: 'green.500',
        },
        _checked: {
          borderColor: 'green.500',
        },
      },
    },
    alert: {
      control: {
        borderColor: 'orange.500',
        _hover: {
          borderColor: 'orange.500',
        },
        _focusVisible: {
          borderColor: 'orange.500',
        },
        _checked: {
          borderColor: 'orange.500',
        },
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
};
